import {Component, ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {state, style, transition, animate, trigger, AUTO_STYLE} from '@angular/animations';
import 'rxjs/add/operator/filter';
import {MenuItems} from '../../utils/menu-items/menu-items';
import { LoginService } from '../../services/login.service';
import { Router } from '@angular/router';
import { RouterLinkActive } from '@angular/router';
import { UsuarioService } from '../../services/usuario.service';
import { ClResultado } from '../../utils/dtos/clResultado';
import swal, { SweetAlertType } from 'sweetalert2';
import { NotificationsService } from 'angular2-notifications';
import { DxValidationGroupComponent } from 'devextreme-angular';
import { confirm } from 'devextreme/ui/dialog';
import {DynamicScriptLoaderService} from '../../services/load.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      state('out', style({
        transform: 'translate3d(100%, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
    trigger('slideOnOff', [
      state('on', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      state('off', style({
        transform: 'translate3d(100%, 0, 0)'
      })),
      transition('on => off', animate('400ms ease-in-out')),
      transition('off => on', animate('400ms ease-in-out'))
    ]),
    trigger('mobileMenuTop', [
      state('no-block, void',
        style({
          overflow: 'hidden',
          height: '0px',
        })
      ),
      state('yes-block',
        style({
          height: AUTO_STYLE,
        })
      ),
      transition('no-block <=> yes-block', [
        animate('400ms ease-in-out')
      ])
    ])
  ]
})
export class AdminComponent implements OnInit {
  deviceType = 'desktop';
  verticalNavType = 'expanded';
  verticalEffect = 'shrink';
  chatToggle = 'out';
  chatInnerToggle = 'off';
  innerHeight: string;
  isScrolled = false;
  isCollapsedSideBar = 'no-block';
  isCollapsedMobile = 'no-block';
  toggleOn = true;
  windowWidth: number;
  txtBtn: string = 'Mostrar Texto';

  clase: String = 'nav-link';
  clase1: String = 'nav-link active';
  @ViewChild('searchFriends') search_friends: ElementRef;
  @ViewChild('toggleButton') toggle_button: ElementRef;
  @ViewChild('sideMenu') side_menu: ElementRef;
  @ViewChild('val1') validationGroup: DxValidationGroupComponent;
  config: any;
  valor: Boolean = false;
  habilitarPopUpContra: Boolean = false;
  pass: string;
  pass1: string;
  ocultarBaja: boolean;
  loadAPI: Promise<any>;
  mostrarInfoCovid:boolean;
  infoMostrar: boolean;
  constructor(public menuItems: MenuItems, public loginService: LoginService,
     private router: Router, private servicePNotify: NotificationsService,
    public usuarioService: UsuarioService, private dynamicScriptLoader: DynamicScriptLoaderService) {
    const scrollHeight = window.screen.height - 150;
    this.innerHeight = scrollHeight + 'px';
    this.windowWidth = window.innerWidth;
    this.setMenuAttributs(this.windowWidth);
  }


  ngOnInit() {
  //  this.loadScripts();
    this.detectarPlatform();
    const info = sessionStorage.getItem('LeidoCovid');
    if(info =='false'){
      this.mostrarInfoCovid=true;
      this.infoMostrar = false;
    } else {
      this.mostrarInfoCovid=false;
      this.infoMostrar = true;
    }
    if (this.loginService.getRol() === 'AINIA') {
      this.ocultarBaja = false;
    } else {
      this.ocultarBaja = true;
    }
 
  }
  verCosas(){
    if (this.txtBtn == 'Mostrar Texto') this.txtBtn = 'Mostrar Infografía';
    else this.txtBtn = 'Mostrar Texto';
  }
  ngAfterView() {
    const boton = document.getElementById('avatar-row');
  }
  abrirContacto() {
    this.usuarioService.habilitarPopUpContacto = true;
  }

  noMostrar(event) {
    if (event.target.checked) {
      this.loginService.FinMostrarInformacion().then(data => {
        if (data.Codigo >= 0) {
          sessionStorage.setItem('LeidoCovid', 'true');
          this.infoMostrar = true;
        }
      });
    }
  }

  detectarPlatform() {
    // tslint:disable-next-line:no-var-keyword
    // tslint:disable-next-line:prefer-const
    let device = navigator.userAgent;

    if (device.match(/Iphone/i) || device.match(/Ipod/i) || device.match(/Android/i) || device.match(/J2ME/i) ||
     device.match(/BlackBerry/i) || device.match(/iPhone|iPad|iPod/i) || device.match(/Opera Mini/i) || device.match(/IEMobile/i) ||
      device.match(/Mobile/i) || device.match(/Windows Phone/i) || device.match(/windows mobile/i) || device.match(/windows ce/i) ||
       device.match(/webOS/i) || device.match(/palm/i) || device.match(/bada/i) || device.match(/series60/i) || device.match(/nokia/i) ||
        device.match(/symbian/i) || device.match(/HTC/i) || device.match(/CriOS/i)) {
    window.location.href = 'https://portalconsumidorapp.ainia.es/';
    } else {
      console.log('no haces nada');
    }
  }
  onClickedOutside(e: Event) {
    if (this.windowWidth < 768 && this.toggleOn && this.verticalNavType !== 'offcanvas') {
      this.toggleOn = true;
      this.verticalNavType = 'offcanvas';
    }
  }
  abrirChatBox() {
    const boton = document.getElementById('avatar-row');
    boton.click();
  }

  onResize(event) {
    this.innerHeight = event.target.innerHeight + 'px';
    /* menu responsive */
    this.windowWidth = event.target.innerWidth;
    let reSizeFlag = true;
    if (this.deviceType === 'tablet' && this.windowWidth >= 768 && this.windowWidth <= 1024) {
      reSizeFlag = false;
    } else if (this.deviceType === 'mobile' && this.windowWidth < 768) {
      reSizeFlag = false;
    }

    if (reSizeFlag) {
      this.setMenuAttributs(this.windowWidth);
    }
  }

  setMenuAttributs(windowWidth) {
    if (windowWidth >= 768 && windowWidth <= 1024) {
      this.deviceType = 'tablet';
      this.verticalNavType = 'offcanvas';
      this.verticalEffect = 'push';
    } else if (windowWidth < 768) {
      this.deviceType = 'mobile';
      this.verticalNavType = 'offcanvas';
      this.verticalEffect = 'overlay';
    } else {
      this.deviceType = 'desktop';
      this.verticalNavType = 'expanded';
      this.verticalEffect = 'shrink';
    }
  }

  searchFriendList(event) {
    const search = (this.search_friends.nativeElement.value).toLowerCase();
    let search_input: string;
    let search_parent: any;
    const friendList = document.querySelectorAll('.userlist-box .media-body .chat-header');
    Array.prototype.forEach.call(friendList, function(elements, index) {
      search_input = (elements.innerHTML).toLowerCase();
      search_parent = (elements.parentNode).parentNode;
      if (search_input.indexOf(search) !== -1) {
        search_parent.classList.add('show');
        search_parent.classList.remove('hide');
      } else {
        search_parent.classList.add('hide');
        search_parent.classList.remove('show');
      }
    });
  }

  toggleChat() {
    this.chatToggle = this.chatToggle === 'out' ? 'in' : 'out';
  }

  toggleChatInner() {
    this.chatInnerToggle = this.chatInnerToggle === 'off' ? 'on' : 'off';
  }

  toggleOpened() {
    if (this.windowWidth < 768) {
      this.toggleOn = this.verticalNavType === 'offcanvas' ? true : this.toggleOn;
      this.verticalNavType = this.verticalNavType === 'expanded' ? 'offcanvas' : 'expanded';
    } else {
      this.verticalNavType = this.verticalNavType === 'expanded' ? 'offcanvas' : 'expanded';
    }
  }
  onMobileMenu() {
    this.isCollapsedMobile = this.isCollapsedMobile === 'yes-block' ? 'no-block' : 'yes-block';
  }

  onScroll(event) {
    this.isScrolled = false;
  }

  toggleOpenedSidebar() {
    this.isCollapsedSideBar = this.isCollapsedSideBar === 'yes-block' ? 'no-block' : 'yes-block';
  }

  onCerrarSesion() {
    this.loginService.cerrarSesion();
    this.usuarioService.listaConsumidoresBuscador = [];
    this.usuarioService.mensajesChat = [];
    this.usuarioService.nombreConsumidorChat = '';
  }
  cambiarClase() {
    if ( this.clase1.includes('active')) {
      this.clase1 = 'nav-link';
      this.clase = 'nav-link active';
    } else {
      this.clase1 = 'nav-link active';
      this.clase = 'nav-link';
    }
  }


  MostrartPopUp() {
    this.usuarioService.habilitarPopUpContra = true;
  }


  cambiarPassword() {
    const result = this.validationGroup.instance.validate();
        if (result.isValid) {
    if (this.pass === this.pass1) {
      this.usuarioService.cambiarContrasenya(this.pass).then(x => this.onEnviarFormulario(x));

    } else {
      this.servicePNotify.error('ERROR', 'Las contraseñas no son iguales');
    }
  }
  }
  onEnviarFormulario(res: ClResultado) {
    if (res.Codigo >= 0) {
      let tipoMensaje: SweetAlertType;
      if (res.Mensaje.indexOf('error') === -1) {
        tipoMensaje = 'success';
      } else { tipoMensaje =  'warning'; }
      this.usuarioService.habilitarPopUpContra = false;
        swal(
          'Hecho',
          res.Mensaje,
          tipoMensaje
        ).then((result) => {
        });
    } else {
      this.servicePNotify.error('ERROR', res.Mensaje);
    }
  }
  comprobarToken() {
    if ( sessionStorage.getItem('idConsumidor') && sessionStorage.getItem('rol') === 'AINIA') {
      this.usuarioService.ObtenerTokenConsumidores(sessionStorage.getItem('idConsumidor')).then(
        data => {
          this.loginService.setToken(data.Token);
          this.loginService.setNombreUsuario(data.NombreUsuario);
        });
    } else {
    }
  }
  comprobarToken1() {
    if ( sessionStorage.getItem('idConsumidor') && sessionStorage.getItem('rol') === 'AINIA') {
      this.usuarioService.ObtenerTokenAinia(this.loginService.usuarioAinia, this.loginService.passwordAinia).then( data => {
        this.loginService.setToken(data.Token);
        this.loginService.setNombreUsuario(data.NombreUsuario);
      });
    }
  }
  darseDeBaja() {
    confirm('¿Esta seguro de que quiere dar de baja este usuario?', 'Va a darse de baja').then(res => {
      if (res === true) {
        this.usuarioService.darseDeBaja('WEB').then(x => this.onEnviarFormulario(x));
      }
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/header/admin.component.ts